export default __webpack_public_path__ + "static/media/Janet_Philbin_AHV_In_Moms_We_Trust.08657419.jpg";